/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 23, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path d="M12.4993 1.66797H7.49935C7.03911 1.66797 6.66602 2.04106 6.66602 2.5013V4.16797C6.66602 4.62821 7.03911 5.0013 7.49935 5.0013H12.4993C12.9596 5.0013 13.3327 4.62821 13.3327 4.16797V2.5013C13.3327 2.04106 12.9596 1.66797 12.4993 1.66797Z" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.334 3.33203H15.0007C15.4427 3.33203 15.8666 3.50763 16.1792 3.82019C16.4917 4.13275 16.6673 4.55667 16.6673 4.9987V16.6654C16.6673 17.1074 16.4917 17.5313 16.1792 17.8439C15.8666 18.1564 15.4427 18.332 15.0007 18.332H5.00065C4.55862 18.332 4.1347 18.1564 3.82214 17.8439C3.50958 17.5313 3.33398 17.1074 3.33398 16.6654V4.9987C3.33398 4.55667 3.50958 4.13275 3.82214 3.82019C4.1347 3.50763 4.55862 3.33203 5.00065 3.33203H6.66732" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7.5 11.668H12.5" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 14.168V9.16797" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
